// test1538
(1538 && 0);
